import L from 'leaflet';
import moment from 'moment';
import HttpService from '../../providers/http-service.js';
import MarkerService from '../../providers/markers-service.js';
import Popup from '../../components/popup/popup';

export default class SensorMarker extends L.Marker {
    constructor(info, oid, map) {
        super();
        this.map = map;
        this.data = info;
        this.oid = oid;
        this.type = 'sensor';
        this.httpService = new HttpService();
        this.path = '../../../Scripts/fort-map/dist/images/';
        this.markerService = new MarkerService(this.map);
        this._latlng = this._getMarkerPosition(info.lat, info.lon);
        this.options.icon = this._getObjectIcon();
        this.sensInfo = info.sensInfo;
        this.tm = info.tm;
        this.duration = info.duration;
        const tooltipProps = {
            permanent: true,
            interactive: true,
            direction: 'right',
            offset: new L.Point(15, -15),
            pane: 'routeElementsPane'
        };
        if (info.routeColor) {
            tooltipProps.className = `tooltip-${info.routeColor}-border`;
        }
        let tooltip = L.tooltip(tooltipProps);
        tooltip.setContent(this._getLabel(info.duration));
        tooltip.on('click', (event) => !this.map.isClickBlocked() && this._onClickMarker(event));
        this.bindTooltip(tooltip).openTooltip();
        this.on('click', (event) => !this.map.isClickBlocked() && this._onClickMarker(event));
    }

    getWidthForColision() {
        return 7;
    }

    getHeightForColision() {
        return 7;
    }

    getMarginLeftForColision() {
        return -7;
    }

    getMarginTopForColision() {
        return -7;
    }

    _getMarkerPosition(lat, lon) {
        if ((lat > 90) || (lat < -90)) {
            return new L.LatLng(0, 0);
        }
        else
            return new L.LatLng(lat, lon);
    }

    _getObjectIcon() {
        let iconUrl = this.path;
        iconUrl = iconUrl + 'route-point.png';
        return L.icon({
            iconUrl: iconUrl,
            iconAnchor: [7.5, 7.5],
            iconSize: [15, 15]
        });
    }

    getGroupName() {
        return messages['TrackSens'];
    }

    getTimeTitleForCluster() {
        return messages['Time'];
    }

    getInfoTitleForCluster() {
        return messages['SosCount'];
    }

    getTimeForCluster() {
        return this.tm;
    }

    getInfoForCluster() {
        return this.getSensorsTriggering(this.data.sensInfo);
    }

    _getLabel(seconds) {
        let count = this.getSensorsTriggering(this.data.sensInfo);
        return `
            <div class="tooltip-container">
                <i class="icon-60 coloricon" style="font-family: Flaticon; font-size: 25px;"></i>
                <span class="leaflet-label leaflet-label-inner">${count}</span>
            </div>
        `;
    }

    _getStatusIcon() {
        return `<i class="icon-60 coloricon" style="font-family: Flaticon; font-size: 25px;"></i>`;
    }

    _onClickMarker(e) {
        let latLng = this.getLatLng();
        this.httpService.getData('/GetInfoForPopupPointOnMap?lat=' + latLng.lat + '&lon=' + latLng.lng + '&oid=' + this.oid)
            .then(
                data => {
                    this.initPopup(data);
                    this._showPopup();
                },
                error => { }
            );
    }

    getIconForClusterGroup() {
        return "\ue93b";
    }

    getClusterType() {
        return this.type;
    }

    getSensorsTriggering(sensors = []) {
        let count = 0;
        for (let sensor of sensors) {
            count = count + sensor.cnt;
        }
        return count;
    }

    initPopup(data) {
        let title = data.Name;
        let popupData = [];
        for (let sensor of this.data.sensInfo) {
            popupData.unshift({ name: sensor.sensorName, val: sensor.cnt });
        }
        popupData.unshift({
            name: messages['Time'],
            ico: "",
            val: moment(fmtools.getLocalDateTime(this.data.tm))
                    .format(messages['moment_data_time_format'])
        });
        popupData.unshift({ name: messages['IMEI'], val: data.IMEI });
        this.popup = new Popup(this.map, title, popupData, this.getLatLng());
    }

    _showPopup(data) {
        this.popup.show();
    }
}
